module.exports = __webpack_public_path__ + "img/斜面操作台.ad08e007.jpg";